import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { FcOutlinedSelectModule } from '../../base/fc-outlined-select/fc-outlined-select.module';
import { FcDeadlineContractOutlinedSelectComponent } from './fc-deadline-contract-outlined-select.component';

@NgModule({
  declarations: [
    FcDeadlineContractOutlinedSelectComponent
  ],
  imports: [
    CommonModule,
    FuseSharedModule,
    FcOutlinedSelectModule
  ],
  providers: [],
  exports: [
    FcDeadlineContractOutlinedSelectComponent
  ]
})
export class FcDeadlineContractOutlinedSelectModule { }
